/* src/components/pages/Misdatos.jsx - Última Modificación: 03-01-2026 */
/* ------------------------------------------------------------------- */

import {
  useEffect,
  useMemo,
  useState,
  useCallback
} from "react";

import {
  Box,
  Button,
  Divider,
  FormControl,
  FormHelperText,
  InputLabel,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Card,
  MenuItem,
  TextField,
  Typography,
  Tooltip,
  Select,
  Stack,
  Collapse,
  CircularProgress,
  FormControlLabel,
  Checkbox
} from '@mui/material';

import api from '../../services/api.js'; // Api Interceptor en vez de Axios

import { DataGrid } from "@mui/x-data-grid";
import { esES } from "@mui/x-data-grid/locales";
import { CustomToolbar } from "../../components/datagrid/CustomToolbar";
import DataGridSkeleton from "../../components/datagrid/DataGridSkeleton";

import { exportPdfAsync, downloadBlob } from "../utils/exportUtils";
import { normalizeRut } from "../utils/rutUtils";

import { RiSave3Fill, RiReplyAllFill, RiFolderDownloadLine,
         RiShareBoxFill, RiFileEditLine } from "react-icons/ri";

import { useAuth } from "../../context/AuthContext"; // token

/* Dialogo de confirmacion */
import ConfirmDialog from '../../components/common/ConfirmDialog';
import { useFeedback } from '../../context/FeedbackContext'; // Mensajes breves

/* Campos para exportar a Csv desde el backend */
const CSV_FIELDS = [
  { key: 'fecing_cli', label: 'Fecha Ingreso' },
  { key: 'rut_cli', label: 'RUT' },
  { key: 'nombre_cli', label: 'Nombre' },
  { key: 'direccion_cli', label: 'Domicilio' },
  { key: 'comuna_cli', label: 'Comuna' },
  { key: 'ciudad_cli', label: 'Ciudad' },
  { key: 'telefono_cli', label: 'Teléfono' },
  { key: 'email_cli', label: 'Email' },
  { key: 'nomban1', label: 'Banco 1' },
  { key: 'ctacte1_cli', label: 'Ctacte 1' },
  { key: 'nomban2', label: 'Banco 2' },
  { key: 'ctacte2_cli', label: 'Ctacte 2' },
  { key: 'nomban3', label: 'Banco 3' },
  { key: 'ctacte3_cli', label: 'Ctacte 3' },
];

const Misdatos = ({ modo }) => {
  const { user } = useAuth();

  const [cliente, setCliente] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [editingCliente, setEditingCliente] = useState(null);

  const [idCli, setIdCli] = useState(0);
  const [rutCli, setRutCli] = useState('');
  const [nombreCli, setNombreCli] = useState('');
  const [direccionCli, setDireccionCli] = useState('');
  const [comunaCli, setComunaCli] = useState('');
  const [ciudadCli, setCiudadCli] = useState('');
  const [telefonoCli, setTelefonoCli] = useState('');
  const [emailCli, setEmailCli] = useState('');
  const [clavesiiCli, setClavesiiCli] = useState('');
  const [claveunicaCli, setClaveunicaCli] = useState('');
  const [banco1Cli, setBanco1Cli] = useState('');
  const [banco2Cli, setBanco2Cli] = useState('');
  const [banco3Cli, setBanco3Cli] = useState('');
  const [ctacte1Cli, setCtacte1Cli] = useState('');
  const [ctacte2Cli, setCtacte2Cli] = useState('');
  const [ctacte3Cli, setCtacte3Cli] = useState('');

  const [bancos, setBancos] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);

  const handleCloseModal = () => setOpen(false);

  /* Dialogo y confirmación */
  const [confirmOpen, setConfirmOpen] = useState(false);
  const { showFeedback } = useFeedback(); // Mensajes breves no bloqueantes

  const [generandoPdf, setGenerandoPdf] = useState(false);

  const [openCsvDialog, setOpenCsvDialog] = useState(false);

  /* Selecciona todos los campos para Csv */
  const [selectedCsvFields, setSelectedCsvFields] = useState(
    CSV_FIELDS.map(f => f.key)
  );

  /* Esconder claves */
  const [showClaves, setShowClaves] = useState(false);

  const [errors, setErrors] = useState({});

  const bancosState = [
    { value: banco1Cli, error: errors.banco1Cli, name: 'banco1Cli', label: 'Banco-1' },
    { value: banco2Cli, error: errors.banco2Cli, name: 'banco2Cli', label: 'Banco-2' },
    { value: banco3Cli, error: errors.banco3Cli, name: 'banco3Cli', label: 'Banco-3' },
  ];

  const cuentasState = [
    { value: ctacte1Cli, error: errors.ctacte1Cli, name: 'ctacte1Cli', label: 'Ctacte-1' },
    { value: ctacte2Cli, error: errors.ctacte2Cli, name: 'ctacte2Cli', label: 'Ctacte-2' },
    { value: ctacte3Cli, error: errors.ctacte3Cli, name: 'ctacte3Cli', label: 'Ctacte-3' },
  ];


  /* Obtener Mis Datos */
  const fetchMisDatos = useCallback(async () => {
    try {
      setLoading(true);

      const RutCli = normalizeRut(user.usuario)

      const response = await api.post('/clientes/getmisdatos', {
        RutCli,
      });

      if (response.data.success && response.data.rows.length > 0) {
        setCliente(response.data.rows);
      }

    } catch (error) {
      setCliente([]);
      console.error('Error al cargar mis datos', error);
    } finally {
      setLoading(false);
    }
  }, [user.usuario]);

  useEffect(() => {
    if (user.usuario) {
      fetchMisDatos();
    }
  }, [user.usuario, fetchMisDatos]);


 /* Cargar bancos desde tabla bancos */
  const fetchBancos = useCallback(async () => {
    try {
      const response = await api.post('/registrarse/getbancos', {
        idBan: 0
      });

      if (response.data.success && response.data.rows) {
        setBancos(response.data.rows); // Asigna los datos al estado //
      } else {
        setBancos([]);
      }

    } catch (error) {
      setBancos([]);
    }
  }, []);

  /* carga los bancos */
  useEffect(() => {
    fetchBancos();
  }, [fetchBancos]);

  /* Validar bancos y ctasctes */
  const validateBankPair = (banco, cuenta, idx, newErrors) => {
    const bancoKey = `banco${idx}Cli`;
    const cuentaKey = `ctacte${idx}Cli`;

    /* limpiar primero */
    newErrors[bancoKey] = '';
    newErrors[cuentaKey] = '';

    const cuentaValida = cuenta && cuenta.trim() !== '';
    const bancoValido = banco

    if (bancoValido && !cuentaValida) {
      newErrors[cuentaKey] = `Debe ingresar la Ctacte ${idx}`;
    } else if (!bancoValido && cuentaValida) {
      newErrors[bancoKey] = `Debe seleccionar el Banco ${idx}`;
    }
  };

  /* Validación de formato de email con Expresión regular */
  const validarEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  /* Manejo de cambio y validaciones de input */
  const handleInputChange = async (e, fieldName) => {
    const { value } = e.target;
    let newErrors = { ...errors };

    switch (fieldName) {
      case 'nombreCli':
        setNombreCli(value);
        newErrors.nombreCli = value.trim() === '' ? 'Debe ingresar el nombre' : '';
        break;

      case 'direccionCli':
        setDireccionCli(value);
        newErrors.direccionCli = value.trim() === '' ? 'Debe ingresar la dirección' : '';
        break;

      case 'comunaCli':
        setComunaCli(value);
        newErrors.comunaCli = value.trim() === '' ? 'Debe ingresar la comuna' : '';
        break;

      case 'ciudadCli':
        setCiudadCli(value);
        newErrors.ciudadCli = value.trim() === '' ? 'Debe ingresar la ciudad' : '';
        break;

      case 'telefonoCli':
        setTelefonoCli(value);
        newErrors.telefonoCli = value.trim() === '' ? 'Debe ingresar el teléfono' : '';
        break;

      case 'emailCli':
        setEmailCli(value);
        newErrors.emailCli =
          value.trim() === '' || !validarEmail(value) ? 'El email ingresado no es válido' : '';
        break;

      case 'clavesiiCli':
        setClavesiiCli(value);
        newErrors.clavesiiCli = value.trim() === '' ? 'Debe ingresar la clave del SII' : '';
        break;

      case 'claveunicaCli':
        setClaveunicaCli(value);
        newErrors.claveunicaCli = '';
        break;

      /* Bancos y Ctacte */
      case 'banco1Cli':
        setBanco1Cli(value);
        break;
      case 'ctacte1Cli':
        setCtacte1Cli(value);
        break;
      case 'banco2Cli':
        setBanco2Cli(value);
        break;
      case 'ctacte2Cli':
        setCtacte2Cli(value);
        break;
      case 'banco3Cli':
        setBanco3Cli(value);
        break;
      case 'ctacte3Cli':
        setCtacte3Cli(value);
        break;

      default:
        break;
    }

    /* Validación bancos/cuentas con valores actualizados */
    validateBankPair(
      fieldName === 'banco1Cli' ? value : banco1Cli,
      fieldName === 'ctacte1Cli' ? value : ctacte1Cli,
      1,
      newErrors
    );

    validateBankPair(
      fieldName === 'banco2Cli' ? value : banco2Cli,
      fieldName === 'ctacte2Cli' ? value : ctacte2Cli,
      2,
      newErrors
    );

    validateBankPair(
      fieldName === 'banco3Cli' ? value : banco3Cli,
      fieldName === 'ctacte3Cli' ? value : ctacte3Cli,
      3,
      newErrors
    );

    /* Validación global */
    const hasErrors = Object.values(newErrors).some(err => err && err !== '');
    const requiredFields = [
      rutCli,
      fieldName === 'nombreCli' ? value : nombreCli,
      fieldName === 'direccionCli' ? value : direccionCli,
      fieldName === 'comunaCli' ? value : comunaCli,
      fieldName === 'ciudadCli' ? value : ciudadCli,
      telefonoCli,
      emailCli,
      fieldName === 'clavesiiCli' ? value : clavesiiCli
    ];
    const hasEmptyFields = requiredFields.some(field => !field || field.trim() === '');

    setErrors(newErrors);
    setIsFormValid(!hasErrors && !hasEmptyFields);
  };

  /* exportar a pdf todos los datos de la tabla */
  const exportToPDF = async () => {
    exportPdfAsync({
      endpointBase: "/clientes/pdf",
      payload: {
        RutCli: normalizeRut(user.usuario),
        RutEnr: '',
        Tipousr: 1, /* cliente */
      },
      onStart: () => setGenerandoPdf(true),
      onFinish: () => setGenerandoPdf(false),
      onError: (msg) => {
        setGenerandoPdf(false);
        showFeedback({
          message: msg,
          severity: "error",
        });
      },
    });
  };

  /* Abrir Modal para Editar Cliente */
  const handleEdit = (cliente) => {
    setIdCli(cliente.id_cli);
    setRutCli(cliente.rut_cli);
    setNombreCli(cliente.nombre_cli);
    setDireccionCli(cliente.direccion_cli);
    setComunaCli(cliente.comuna_cli);
    setCiudadCli(cliente.ciudad_cli);
    setTelefonoCli(cliente.telefono_cli);
    setEmailCli(cliente.email_cli);
    setClavesiiCli(cliente.clavesii_cli);
    setClaveunicaCli(cliente.claveunica_cli);
    setBanco1Cli(cliente.banco1_cli ? String(cliente.banco1_cli) : '');
    setBanco2Cli(cliente.banco2_cli ? String(cliente.banco2_cli) : '');
    setBanco3Cli(cliente.banco3_cli ? String(cliente.banco3_cli) : '');
    setCtacte1Cli(cliente.ctacte1_cli);
    setCtacte2Cli(cliente.ctacte2_cli);
    setCtacte3Cli(cliente.ctacte3_cli);
    setEditingCliente(cliente);
    setIsFormValid(false);
    setShowClaves(false);
    setOpen(true);

    /* Limpiar el error de todos los input */
    setErrors({});
  };

  /* 🔧 Recalcular isFormValid automáticamente al entrar en modo edición */
  useEffect(() => {
    if (open && editingCliente) {
      const requiredFields = [
        rutCli,
        nombreCli,
        direccionCli,
        comunaCli,
        ciudadCli,
        telefonoCli,
        emailCli,
        clavesiiCli,
      ];

      const hasEmptyFields = requiredFields.some(
        (field) => !field || field.trim() === ''
      );

      const hasErrors = Object.values(errors).some(
        (err) => err && err !== ''
      );

      setIsFormValid(!hasEmptyFields && !hasErrors);
    }
  }, [
    open,
    editingCliente,
    rutCli,
    nombreCli,
    direccionCli,
    comunaCli,
    ciudadCli,
    telefonoCli,
    emailCli,
    clavesiiCli,
    errors,
  ]);


  /* Helpers de Selección de campos para exportar a Csv */
  const toggleCsvField = (fieldKey) => {
    setSelectedCsvFields(prev =>
      prev.includes(fieldKey)
        ? prev.filter(k => k !== fieldKey)
        : [...prev, fieldKey]
    );
  };

  /* Llama a crear Csv */
  const handleExportCsv = async () => {
    try {
      const RutCli = normalizeRut(user.usuario);

      const response = await api.post('/clientes/csv',
        {
          RutCli,
          fields: selectedCsvFields,
        },
        {
          responseType: 'blob',
        }
      );

      downloadBlob(response.data, "mis_datos.csv");
      setOpenCsvDialog(false);

    } catch (error) {
      showFeedback({
        message: 'No fue posible exportar el CSV',
        severity: 'error',
      });
    }
  };

  /* MUI DataGrid */
  const columns = useMemo(
    () => [
      {
        field: 'actions',
        headerName: 'Acciones',
        width: 100,
        sortable: false,
        filterable: false,
        headerAlign: 'center',
        align: 'center',
        renderCell: (params) => {

          /* 🔐 Solo CLIENTE puede editar SUS datos */
          if (user?.tipo !== 'CLIENTE') return null;

          const row = params.row;

          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Tooltip title="Editar" placement="top" arrow>
                <Button
                  onClick={() => handleEdit(row)}
                  variant="contained"
                  size="small"
                  sx={{
                    backgroundColor: (theme) => theme.custom.ui.primaryAction,
                    color: (theme) => theme.custom.ui.primaryActionText,
                    minWidth: 0,
                    padding: 0,
                    width: 30,
                    height: 22,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    '&:hover': (theme) => theme.custom.ui.primaryActionHover,
                  }}
                >
                  <RiFileEditLine size={18} />
                </Button>
              </Tooltip>
            </div>
          );
        },
      },
      {
        field: "nombre_cli",
        headerName: "Razón Social",
        width: 350,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "direccion_cli",
        headerName: "Dirección",
        width: 350,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "comuna_cli",
        headerName: "Comuna",
        width: 200,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "ciudad_cli",
        headerName: "Ciudad",
        width: 140,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "telefono_cli",
        headerName: "Teléfono",
        width: 180,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "email_cli",
        headerName: "Email",
        width: 338,
        flex: 1,
        align: "center",
        headerAlign: "center",
      },
    ],
    [user?.tipo]
  );

  /* Validación de datos */
  const handleSave = async () => {
    const validationErrors = {};

    if (!rutCli) validationErrors.rutCli = 'El Rut es obligatorio';
    if (!nombreCli) validationErrors.nombreCli = 'El Nombre es obligatorio';
    if (!direccionCli) validationErrors.direccionCli = 'La Dirección es obligatoria';
    if (!comunaCli) validationErrors.comunaCli = 'La Comuna es obligatoria';
    if (!ciudadCli) validationErrors.ciudadCli = 'La Ciudad es obligatoria';
    if (!telefonoCli) validationErrors.telefonoCli = 'El Teléfono es obligatorio';
    if (!emailCli) validationErrors.emailCli = 'El Email es obligatorio';

    if (banco1Cli && !ctacte1Cli) validationErrors.ctacte1Cli = 'Debe ingresar Ctacte 1';
    if (ctacte1Cli && !banco1Cli) validationErrors.banco1Cli = 'Debe seleccionar el Banco 1';

    if (banco2Cli && !ctacte2Cli) validationErrors.ctacte2Cli = 'Debe ingresar Ctacte 2';
    if (ctacte2Cli && !banco2Cli) validationErrors.banco2Cli = 'Debe seleccionar el Banco 2';

    if (banco3Cli && !ctacte3Cli) validationErrors.ctacte3Cli = 'Debe ingresar Ctacte 3';
    if (ctacte3Cli && !banco3Cli) validationErrors.banco3Cli = 'Debe seleccionar el Banco 3';

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailCli && !emailRegex.test(emailCli)) {
      validationErrors.emailCli = 'El Email no es válido';
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    /* 👉 Abrimos confirmación MUI */
    setConfirmOpen(true);
  };

  /* Función actualizar registro */
  const handleConfirmSave = async () => {
    setConfirmOpen(false);

    /* Normalizar datos */
    const fixRutCli = normalizeRut(rutCli)

    try {
      if (editingCliente) {
        await api.post('/clientes/updatecliente', {
          id_cli: idCli,
          rut_cli: fixRutCli,
          nombre_cli: nombreCli.toUpperCase(),
          direccion_cli: direccionCli.toUpperCase(),
          comuna_cli: comunaCli.toUpperCase(),
          ciudad_cli: ciudadCli.toUpperCase(),
          telefono_cli: telefonoCli,
          email_cli: emailCli.toLowerCase(),
          clavesii_cli: clavesiiCli,
          claveunica_cli: claveunicaCli,
          banco1_cli: banco1Cli ? Number(banco1Cli) : null,
          ctacte1_cli: ctacte1Cli,
          banco2_cli: banco2Cli ? Number(banco2Cli) : null,
          ctacte2_cli: ctacte2Cli,
          banco3_cli: banco3Cli ? Number(banco3Cli) : null,
          ctacte3_cli: ctacte3Cli,
        });
        showFeedback({
          message: 'El cliente fue actualizado correctamente.',
          severity: 'success',
        });
      }
      fetchMisDatos();
      handleCloseModal();

    } catch (error) {
      showFeedback({
        message: 'Hubo un problema al procesar la solicitud, intente más tarde.',
        severity: 'error',
      });
    }
  };

  /* Render de los datos */
  return (
    <Box sx={{ width: '100%', pt: 0, overflow: 'visible' }}>
      {/* Barra de Controles */}
      <Stack
        direction="row"
        spacing={1}
        useFlexGap
        flexWrap="wrap"
        alignItems="center"
        sx={{
          mb: 1,
          flexShrink: 0,       // 👈 NO se colapsa
        }}
      >
        <TextField
          label="Rut"
          value={user?.usuario || ""}
          size="small"
          disabled
          slotProps={{
            inputLabel: { shrink: true },
          }}
          sx={{
            minWidth: 140,
            flexShrink: 0,

            "& .MuiInputBase-root": {
              backgroundColor: (theme) => theme.custom.ui.readonlyBg,
            },

            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.custom.ui.readonlyText,
            },

            "& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.custom.ui.readonlyLabel,
            },
          }}
        />

        <TextField
          label="Cliente"
          value={user?.nombre || ""}
          size="small"
          disabled
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          sx={{
            minWidth: 260,
            flexGrow: 1,
            flexShrink: 0,

            "& .MuiInputBase-root": {
              backgroundColor: (theme) => theme.custom.ui.readonlyBg,
            },

            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: (theme) => theme.custom.ui.readonlyText,
            },

            "& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-disabled": {
              color: (theme) => theme.custom.ui.readonlyLabel,
            },
          }}
        />

        <Button
          variant="contained"
          startIcon={<RiFolderDownloadLine size={18} />}
          disabled={cliente.length === 0}
          onClick={exportToPDF}
          sx={{
            minWidth: 110,
            height: 40,
            flexShrink: 0,

            backgroundColor: (theme) => theme.custom.ui.exportActionBg,
            color: (theme) => theme.custom.ui.exportActionText,
            border: (theme) =>
              `1px solid ${theme.custom.ui.exportActionBorder}`,

            '&:hover': {
              backgroundColor: (theme) =>
                theme.custom.ui.exportActionBgHover,
            },
          }}
        >
          PDF
        </Button>

        {/* Botón Exportar a Csv */}
        <Button
          variant="contained"
          startIcon={<RiShareBoxFill size={18} />}
          disabled={cliente.length === 0}
          onClick={() => setOpenCsvDialog(true)}
          sx={{
            minWidth: 110,
            height: 40,
            backgroundColor: (theme) => theme.custom.ui.exportActionBg,
            color: (theme) => theme.custom.ui.exportActionText,
            border: (theme) =>
              `1px solid ${theme.custom.ui.exportActionBorder}`,

            '&:hover': {
              backgroundColor: (theme) =>
                theme.custom.ui.exportActionBgHover,
            },
          }}
        >
          CSV
        </Button>

      </Stack>


      {/* Configuración MIU DataGrid */}
      <Box
        sx={{
          flexGrow: 1,        // 👈 ocupa el resto del espacio
          minHeight: 300,     // 👈 altura mínima usable
          width: '100%',
          overflow: 'hidden', // 👈 DataGrid maneja su scroll
        }}
      >
        <DataGrid
          rows={cliente}
          columns={columns}
          getRowId={(row) => row.id_cli}
          loading={loading}
          density="compact"
          rowHeight={38}
          headerHeight={40}
          pagination
          disableRowSelectionOnClick
          initialState={{
            pagination: { paginationModel: { pageSize: 10, page: 0 } },
            density: 'compact',
          }}
          pageSizeOptions={[10, 20, 50, 100]}
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          slots={{
            toolbar: CustomToolbar,
            loadingOverlay: DataGridSkeleton,
          }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 400 },
            },
          }}
          sx={{
            height: '100%',
            width: '100%',
            minWidth: 720,      // scroll horizontal cuando corresponde
            border: 'none',
            // accesibilidad / foco
            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
              outline: 'none',
            },
          }}
        />
      </Box>


      {/* Dialog para ingresar o modificar */}
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            handleCloseModal();
          }
        }}
        disableEnforceFocus
        disableRestoreFocus
        fullWidth={false}
        maxWidth={false} // 👈 control total del ancho
      >
        <Card
          sx={{
            width: {
              xs: '95vw',   // móvil
              sm: '90vw',   // tablets
              md: '82vw',   // notebooks
              lg: 900,      // desktop elegante
            },
            maxWidth: 960,

            height: '85vh',
            display: 'flex',
            flexDirection: 'column',

            borderRadius: 2,
            border: (theme) => `1px solid ${theme.custom.ui.borderSubtle}`,
            boxShadow: (theme) => theme.custom.ui.modalShadow,
            overflow: 'hidden',
          }}
        >
          {/* ================= HEADER ================= */}
          <Box px={3} pt={1} pb={1}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Box>
                <Typography variant="h6" fontWeight={600} lineHeight={1.2}>
                  Editar cliente
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Información general y bancaria
                </Typography>
              </Box>

              <Typography variant="caption" color="text.secondary">
                ▶️ Overwatch
              </Typography>
            </Stack>
          </Box>

          <Divider />

          {/* ================= CONTENIDO (SCROLL) ================= */}
          <Box
            sx={{
              flex: 1,
              overflowY: 'auto',
              overflowX: 'hidden',
              px: 3,
              py: 2,
            }}
          >
            {/* ================= DATOS PERSONALES ================= */}
            <Box mb={2}>
              <Typography
                variant="subtitle2"
                fontWeight={600}
                mb={1}
                sx={sectionTitleSx}
              >
                Datos personales
              </Typography>

              <Stack spacing={2}>
                <TextField
                  label="Rut"
                  value={rutCli}
                  disabled
                  sx={{
                    ...fieldSx,
                    width: { xs: '100%', sm: '20%' },
                    '& .MuiInputBase-input.Mui-disabled': {
                      textAlign: 'center',
                      letterSpacing: '0.03em',
                    },
                  }}
                />

                <TextField
                  label="Nombre"
                  value={nombreCli}
                  onChange={(e) => handleInputChange(e, 'nombreCli')}
                  error={Boolean(errors.nombreCli)}
                  helperText={errors.nombreCli}
                  sx={fieldSx}
                  autoFocus
                />

              </Stack>
            </Box>

            {/* ================= UBICACIÓN ================= */}
            <Box mb={2}>
              <Typography
                variant="subtitle2"
                fontWeight={600}
                mb={1}
                sx={sectionTitleSx}
              >
                Ubicación
              </Typography>

              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField
                  label="Dirección"
                  value={direccionCli}
                  onChange={(e) => handleInputChange(e, 'direccionCli')}
                  fullWidth
                  sx={fieldSx}
                  error={Boolean(errors.direccionCli)}
                  helperText={errors.direccionCli}
                />

                <TextField
                  label="Comuna"
                  value={comunaCli}
                  onChange={(e) => handleInputChange(e, 'comunaCli')}
                  fullWidth
                  sx={fieldSx}
                  error={Boolean(errors.comunaCli)}
                  helperText={errors.comunaCli}

                />

                <TextField
                  label="Ciudad"
                  value={ciudadCli}
                  onChange={(e) => handleInputChange(e, 'ciudadCli')}
                  fullWidth
                  sx={fieldSx}
                  error={Boolean(errors.ciudadCli)}
                  helperText={errors.ciudadCli}
                />
              </Stack>
            </Box>

            {/* ================= CONTACTO ================= */}
            <Box mb={2}>
              <Typography
                variant="subtitle2"
                fontWeight={600}
                mb={1}
                sx={sectionTitleSx}
              >
                Contacto
              </Typography>

              <Stack spacing={2}>
                <TextField
                  label="Teléfono"
                  value={telefonoCli}
                  onChange={(e) => handleInputChange(e, 'telefonoCli')}
                  error={Boolean(errors.telefonoCli)}
                  helperText={errors.telefonoCli}
                  sx={fieldSx}
                />

                <TextField
                  label="Email"
                  value={emailCli}
                  onChange={(e) => handleInputChange(e, 'emailCli')}
                  error={Boolean(errors.emailCli)}
                  helperText={errors.emailCli}
                  sx={fieldSx}
                />
              </Stack>
            </Box>

            {/* ================= CLAVES ================= */}
            <Box mb={2}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                flexWrap="wrap"
                gap={1}
              >
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  sx={sectionTitleSx}
                >
                  Claves
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Información sensible. Mostrar solo si es necesario.
                </Typography>

                <Button
                  size="small"
                  onClick={() => setShowClaves((prev) => !prev)}
                  sx={{ textTransform: 'none' }}
                >
                  {showClaves ? 'Ocultar claves' : 'Mostrar claves'}
                </Button>
              </Stack>
            </Box>

            <Collapse
              in={showClaves}
              timeout={300}
              easing={{
                enter: 'cubic-bezier(0.4, 0, 0.2, 1)',
                exit: 'cubic-bezier(0.4, 0, 0.2, 1)',
              }}
            >
              <Box mb={2}>
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  spacing={2}
                >
                  <TextField
                    label="Clave SII"
                    value={clavesiiCli}
                    onChange={(e) => handleInputChange(e, 'clavesiiCli')}
                    error={Boolean(errors.clavesiiCli)}
                    helperText={errors.clavesiiCli}
                    sx={fieldSx}
                    fullWidth
                  />

                  <TextField
                    label="Clave Única"
                    value={claveunicaCli}
                    onChange={(e) => handleInputChange(e, 'claveunicaCli')}
                    error={Boolean(errors.claveunicaCli)}
                    helperText={errors.claveunicaCli}
                    sx={fieldSx}
                    fullWidth
                  />
                </Stack>
              </Box>
            </Collapse>

            {/* ================= BANCOS ================= */}
            <Box mb={2}>
              <Typography
                variant="subtitle2"
                fontWeight={600}
                mb={1}
                sx={sectionTitleSx}
              >
                Bancos asociados
              </Typography>

              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  {bancosState.map((b) => (
                    <FormControl
                      key={b.name}
                      fullWidth
                      error={Boolean(b.error)}
                      sx={fieldSx}
                    >
                      <InputLabel>{b.label}</InputLabel>
                      <Select
                        value={b.value}
                        label={b.label}
                        onChange={(e) => handleInputChange(e, b.name)}
                      >
                        <MenuItem value="">✨ Seleccionar Banco</MenuItem>
                        {bancos.map((ban) => (
                          <MenuItem key={ban.id} value={String(ban.id)}>
                            {ban.nomban}
                          </MenuItem>
                        ))}
                      </Select>
                      {b.error && <FormHelperText>{b.error}</FormHelperText>}
                    </FormControl>
                  ))}
                </Stack>

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  {cuentasState.map((c) => (
                    <TextField
                      key={c.name}
                      label={c.label}
                      value={c.value}
                      onChange={(e) => handleInputChange(e, c.name)}
                      error={Boolean(c.error)}
                      helperText={c.error}
                      sx={fieldSx}
                      fullWidth
                    />
                  ))}
                </Stack>
              </Stack>
            </Box>
          </Box>

          {/* ================= FOOTER ================= */}
          <Divider />

          <Box
            sx={{
              px: 3,
              py: 2, // 👈 compacto pero cómodo
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 1.5, // 👈 mejor que spacing=2
              backgroundColor: 'inherit',
            }}
          >
            <Button
              variant="outlined"
              onClick={handleCloseModal}
              startIcon={<RiReplyAllFill />}
              sx={(theme) => ({
                backgroundColor: theme.custom.ui.secondaryActionBg,
                color: theme.custom.ui.secondaryActionText,
                borderRadius: 8,
                padding: '6px 14px',
                minHeight: 36,
                border: `1px solid ${theme.custom.ui.secondaryActionBorder}`,

                '&:hover': {
                  backgroundColor: theme.custom.ui.secondaryActionBgHover,
                  boxShadow:
                    theme.palette.mode === 'dark'
                      ? `inset 0 0 0 1px ${theme.custom.ui.secondaryActionBorderHover}`
                      : theme.custom.ui.surfaceShadow,
                },
              })}
            >
              Cancelar
            </Button>

            <Button
              variant="contained"
              onClick={handleSave}
              disabled={!isFormValid}
              startIcon={<RiSave3Fill />}
              sx={(theme) => ({
                backgroundColor: theme.custom.ui.primaryActionBg,
                color: theme.custom.ui.primaryActionText,
                borderRadius: 8,
                padding: '6px 16px',
                minHeight: 36,

                boxShadow: theme.custom.ui.primaryActionShadow,

                '&:hover': {
                  backgroundColor: theme.custom.ui.primaryActionBgHover,
                  boxShadow: theme.custom.ui.primaryActionShadowHover,
                },
              })}
            >
              Regrabar
            </Button>
          </Box>
        </Card>
      </Dialog>

      {/* Dialog de confirmación de ConfirmDialog.jsx */}
      <ConfirmDialog
        open={confirmOpen}
        title="¿Guardar cambios?"
        description="Se actualizará la información del cliente."
        confirmText="Sí, guardar"
        onConfirm={handleConfirmSave}
        onCancel={() => setConfirmOpen(false)}
      />

      <Dialog
        open={generandoPdf}
        aria-labelledby="generando-pdf-title"
        aria-describedby="generando-pdf-desc"

        maxWidth="xs"
        fullWidth
        slotProps={{
          paper: {
            sx: (theme) => ({
              borderRadius: 3,
              textAlign: 'center',
              backgroundColor: theme.custom.ui.modalBg,
              boxShadow: theme.custom.ui.modalShadow,
            }),
          },
        }}
      >
        <DialogContent>
          <Stack spacing={2} alignItems="center" py={2}>
            <CircularProgress
              size={42}
              thickness={4}
              sx={{
                color: (theme) => theme.custom.ui.focus,
              }}
            />

            <Typography id="generando-pdf-title" variant="body2">
              Generando reporte
            </Typography>

            <Typography
              id="generando-pdf-desc"
              variant="caption"
              color="text.secondary"
            >
              Estamos trabajando en ello…
            </Typography>
          </Stack>
        </DialogContent>
      </Dialog>


      {/* Dialogo selección de campos para Csv desde el backend */}
      <Dialog
        open={openCsvDialog}
        onClose={() => setOpenCsvDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Box
            sx={{
              mb: 0,
              color: (theme) => theme.custom.ui.brandAccent,
              fontSize: '1.4rem'
            }}>
            Exportar CSV
          </Box>
        </DialogTitle>

        <Divider />

        <DialogContent>
          <Box sx={{ mb: 1, color: 'text.secondary', fontSize: '0.85rem' }}>
            Selecciona los campos que deseas incluir en el archivo.
          </Box>

          <Stack spacing={0.5}>
            {CSV_FIELDS.map(field => (
              <FormControlLabel
                key={field.key}
                control={
                  <Checkbox
                    checked={selectedCsvFields.includes(field.key)}
                    onChange={() => toggleCsvField(field.key)}
                  />
                }
                label={field.label}
              />
            ))}
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpenCsvDialog(false)}
            sx={{
              backgroundColor: (theme) => theme.custom.ui.secondaryActionBg,
              color: (theme) => theme.custom.ui.secondaryActionText,
              '&:hover': {
                backgroundColor: (theme) => theme.custom.ui.secondaryActionBgHover,
              },
            }}
          >
            Cancelar
          </Button>

          <Button
            variant="contained"
            disabled={selectedCsvFields.length === 0}
            onClick={handleExportCsv}
            sx={{
              backgroundColor: (theme) => theme.custom.ui.primaryAction,
              color: (theme) => theme.custom.ui.primaryActionText,
              '&:hover': {
                backgroundColor: (theme) => theme.custom.ui.primaryActionHover,
              },
            }}
          >
            Exportar
          </Button>

        </DialogActions>
      </Dialog>

    </Box>
  );
};

/* Configuracion ux input */
const fieldSx = {
  '& .MuiInputBase-root': {
    height: 30,
    fontSize: 13.5,
  },
  '& .MuiInputLabel-root': {
    fontSize: 12.5,
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0,
    fontSize: '0.7rem',
    minHeight: '1em',
  },
};

const sectionTitleSx = {
  fontWeight: 600,
  fontSize: '0.9rem',
  letterSpacing: '0.02em',
  color: (theme) => theme.custom.ui.titleAccent,
};



export default Misdatos;
